import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useReturnUrl } from '../../toolympus/hooks/auth/useReturnUrl';
import { login, useUser } from '../../toolympus/userContext/UserContext';
import { useHistory } from 'react-router-dom';
import { apiFetch } from '../../toolympus/api/core';
import { useLoadedData } from '../../toolympus/hooks/useLoadedData';
import { LoadingIndicator } from '../../toolympus/components/primitives';
import { PublicPageWrapper } from '../Common/PublicPageWrapper';
import { Typography } from '@mui/material';

interface Props {
  
}

const useLoginKCStart = () => {
  const authUrl = useLoadedData<{ auth_url: string }>("/api/kc-auth/auth-url", { auth_url: "" });

  useEffect(() => {
    if(authUrl.data.auth_url) {
      window.location.href = authUrl.data.auth_url;
    }
  }, [authUrl.data]);

  return {
    isLoading: authUrl.isLoading,
  }
  
}

const useLoginKCComplete = () => {
  const returnUrl = useReturnUrl();

  const userCtx = useUser();
  const history = useHistory();

  const [error,setError] = useState<string>("");

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const code = search.get("code");
    if(!code) {
      setError("no.code");
    } else {
      apiFetch<string>("/api/kc-auth/auth", "post", { code })
        .then(token => {
          login(userCtx, token);
          history.push(returnUrl.fromParam || "/");
        })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    error,
  }
}

export const LoginKCStart = (props: Props) => {
  useLoginKCStart();
  return (
    <PublicPageWrapper>
      <LoadingIndicator sizeVariant="l" />
    </PublicPageWrapper>
  );
}

export const LoginKCComplete = (props: Props) => {
  const { error } = useLoginKCComplete();
  return (
    <PublicPageWrapper>
      {!error && <LoadingIndicator sizeVariant="l" />}
      {!!error && <Typography>Произошла ошибка ({error})</Typography>}
    </PublicPageWrapper>
  );
}

export const ICLRCAuthLogo = styled.img`
  height: 1rem;
  width: auto !important;
`;
ICLRCAuthLogo.defaultProps = { src: "/img/iclrc_auth.svg" };
